module.exports = __webpack_public_path__ + "img/close_black.5611bdcc.svg";